<template>
  <section class="method-detail-container">
    <div
      class="half"
    >
      <span class="title">{{detailData.title_en||'-'}}</span>
      <span class="body-content">{{detailData.body_en||'-'}}</span>
      <span class="title  mg-t-8 mg-b-8">Button URL</span>
      <span
        class="url blue pointer flex-align-center"
        @click="handleUrl(detailData.url_en)">
        <font-awesome-icon
          class="icon"
          icon="link"></font-awesome-icon>
        <span>{{detailData.url_en||'-'}}</span>
      </span>
    </div>
    <div
      class="half"
    >
      <span class="title">{{detailData.title_zh||'-'}}</span>
      <span class="body-content">{{detailData.body_zh||'-'}}</span>
      <span class="title  mg-t-8 mg-b-8">Button URL</span>
      <span
        class="url blue pointer flex-align-center"
        @click="handleUrl(detailData.url_zh)">
        <font-awesome-icon
          class="icon"
          icon="link"></font-awesome-icon>
        <span>{{detailData.url_zh||'-'}}</span>
      </span>
    </div>
  </section>
</template>

<script>
import {getInsurersClaimDetail, setInsurersClaim} from '@api/claim'

export default {
  name: 'method-detail',
  props:{
    detailData:{
      type:Object,
      default:()=>({})
    }
  },
  data(){
    return{
      detail:{}
    }
  },
  methods:{
    handleEdit(){
      this.$emit('method')
    },
    handleUrl(url){
      if(url)
        window.open(url, '_blank')
    }
  }
}
</script>

<style scoped lang="scss">
.method-detail-container{
  display: flex;
  justify-content: space-between;
  .half{
    width: calc(50% - 10px);
    border-radius: 5px;
    border: 1px solid #D1D5DA;
    background: #FFF;
    padding: 16px;
    //margin-right: 20px;
    .body-content{
      display:block;
      color: #6A737D;
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: 20px;
      margin: 8px 0;
    }
    .title{
      color: #24292E;
      display: block;
      font-size: 14px;
      font-style: normal;
      font-weight: 600;
      line-height: 20px; /* 142.857% */
      letter-spacing: -0.15px;
    }
    .url{
      font-size: 14px;
    }
  }
  .icon{
    width: 20px;
    height: 20px;
    font-size: 20px;
    margin-right: 2px;
  }
}
</style>
